import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.3 4.167-.967-.967L8.5 7.033 4.667 3.2l-.967.967L7.533 8 3.7 11.833l.967.967L8.5 8.967l3.833 3.833.967-.967L9.467 8z"
    }, null, -1)
  ])))
}
export default { render: render }